import type { Snack_SnackEditPageQuery } from "@/lib/gql/__generated__/graphql";

import { useCreateSnackFormModel } from "../use-create-snack-form-model";
import { useCreateSnackModel } from "../use-create-snack-model";

type Props = {
	hotelID: string;
	data: Snack_SnackEditPageQuery;
};

export const useInit = ({ hotelID, data }: Props) => {
	const snackFormModel = useCreateSnackFormModel({ hotelID, data: data.snack });

	return {
		snackFormModel,
		...useCreateSnackModel({ hotelID, data, snackFormModel }),
	};
};
